import { ReactNode } from 'react';
import { Header } from './Header';
import { ImpersonationBanner } from '../ImpersonationBanner';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <ImpersonationBanner />
      <Header />
      <main className="container mx-auto px-4 py-8 md:px-6">
        {children}
      </main>
    </div>
  );
}
